/**
 * ARIA App Component
 * Version: 1.0.0
 */

import { useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { DashboardLayout } from './components/layout/DashboardLayout';
import { RequireAuth } from './components/auth/RequireAuth';
import { Restricted } from './components/auth/Restricted';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import AuthCallback from './pages/AuthCallback';
import Dashboard from './pages/Dashboard';
import Jobs from './pages/Jobs';
import ScheduledJobs from './pages/ScheduledJobs';
import InProgressJobs from './pages/InProgressJobs';
import PendingParts from './pages/PendingParts';
import PendingDebrief from './pages/PendingDebrief';
import Warranty from './pages/Warranty';
import Technicians from './pages/Technicians';
import Booking from './pages/Booking';
import AdminSettings from './pages/Settings/AdminSettings';
import { ChatInterface, ChatToggleButton } from './components/ChatInterface';

function App() {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const location = useLocation();
  const PUBLIC_ROUTES = ['/login', '/forgot-password', '/reset-password', '/auth/callback'];
  const isLoginRoute = PUBLIC_ROUTES.includes(location.pathname);

  return (
    <>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route element={<RequireAuth />}>
          <Route path="/" element={<DashboardLayout />}>
            <Route index element={<Restricted><Dashboard /></Restricted>} />
            <Route path="jobs" element={<Restricted><Jobs /></Restricted>} />
            <Route path="jobs/scheduled" element={<Restricted><ScheduledJobs /></Restricted>} />
            <Route path="jobs/in-progress" element={<Restricted><InProgressJobs /></Restricted>} />
            <Route path="pending-parts" element={<Restricted><PendingParts /></Restricted>} />
            <Route path="pending-debrief" element={<Restricted><PendingDebrief /></Restricted>} />
            <Route path="warranty" element={<Warranty />} />
            <Route path="technicians" element={<Restricted><Technicians /></Restricted>} />
            <Route path="booking" element={<Restricted><Booking /></Restricted>} />
            {/* ARIA-15: Technician Profile under Settings */}
            <Route path="admin" element={<AdminSettings />} />
          </Route>
        </Route>
      </Routes>

      {/* AI Chat Interface — hidden on the login route, since chat queries require auth */}
      {!isLoginRoute &&
        (isChatOpen ? (
          <ChatInterface isOpen={isChatOpen} onClose={() => setIsChatOpen(false)} />
        ) : (
          <ChatToggleButton onClick={() => setIsChatOpen(true)} />
        ))}
    </>
  );
}

export default App;
